/**
 * The registers under Product settings, in the design's tab order (screens/master-data.html), and
 * the Xero accounts last (ALS-386), which no frame draws: the chart a product and a line post to.
 */
export const REGISTERS = [
    'categories',
    'brands',
    'colours',
    'colour-groups',
    'sizes',
    'sale-sources',
    'commodity-codes',
    'xero-accounts',
] as const;
export type RegisterKey = (typeof REGISTERS)[number];

/**
 * The registers that are master data in the legacy role matrix: Admin alone changes them, every
 * other role reads them (ADR 0102). Brands and commodity codes stay with whoever edits products.
 */
export const ADMIN_ONLY_REGISTERS: ReadonlySet<RegisterKey> = new Set([
    'categories',
    'colours',
    'colour-groups',
    'sizes',
    'sale-sources',
]);
